import { ReactNode } from "react";

import { Collapse } from "../../../Collapse";
import { Typo } from "../../../Typo";

export type ChartSectionEntryProps = {
  title: string;
  subtitle?: string;
  isMobile?: boolean;
  chart: ReactNode;
  chartMini?: ReactNode;
  filterControls?: ReactNode;
};

export const ChartSectionEntry = ({
  title,
  subtitle,
  isMobile = false,
  chart,
  chartMini,
  filterControls,
}: ChartSectionEntryProps) => {
  return (
    <div className="flex flex-col rounded-xl lg:mb-10">
      <div className="flex h-full w-full flex-col rounded-xl bg-surface-brand-subtle p-4 lg:p-6">
        <Collapse
          isMobile={isMobile}
          previewContent={chartMini}
          detailsContent={
            <>
              <ChartHeader
                isMobile={isMobile}
                title={title}
                subtitle={subtitle}
                filterControls={filterControls}
              />
              <div className="my-4 lg:my-6">{chart}</div>
            </>
          }
        />
      </div>
    </div>
  );
};

type ChartHeaderProps = {
  isMobile?: boolean;
  title: string;
  subtitle?: string;
  filterControls?: ReactNode;
};

const ChartHeader = ({
  isMobile,
  title,
  subtitle,
  filterControls,
}: ChartHeaderProps) => {
  return (
    <div className="flex flex-col-reverse justify-stretch gap-4 lg:flex-row lg:items-start lg:justify-between">
      <div className="flex flex-col items-start gap-2">
        <Typo
          type={isMobile ? "labelSM" : "labelMD"}
          textColor={isMobile ? "text-text-secondary" : "text-text-primary"}
        >
          {title}
        </Typo>
        {subtitle && (
          <Typo type="bodySM" textColor="text-text-tertiary">
            {subtitle}
          </Typo>
        )}
      </div>

      {filterControls}
    </div>
  );
};
